interface ApiResponse<T = unknown> {
  success: boolean;
  message: string;
  data?: T;
}

export const apiCall = async <T = unknown>(endpoint: string, options: RequestInit = {}): Promise<ApiResponse<T>> => {
  const defaultOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  };

  // Add session token to headers if it exists
  const accessToken = localStorage.getItem('sb-access-token');
  const refreshToken = localStorage.getItem('sb-refresh-token');
  
  if (accessToken && refreshToken) {
    defaultOptions.headers = {
      ...defaultOptions.headers,
      'Authorization': `Bearer ${accessToken}`,
      'X-Refresh-Token': refreshToken
    };
  }

  console.log(`Making API call to: ${endpoint}`);
  console.log('Request options:', { ...defaultOptions, ...options });

  const response = await fetch(endpoint, { ...defaultOptions, ...options });
  console.log(`Response status: ${response.status}`);
  
  if (!response.ok) {
    console.error(`HTTP error! status: ${response.status}`);
    if (response.status === 401) {
      try {
        localStorage.removeItem('sb-access-token');
        localStorage.removeItem('sb-refresh-token');
      } catch (storageError) {
        console.debug('Failed to clear auth tokens', storageError);
      }
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/signin')) {
        window.location.assign('/signin');
      }
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const responseData = await response.json();
  console.log(`Response data for ${endpoint}:`, responseData);
  
  return responseData;
}; 